import React, { useEffect } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import Markdown from 'markdown-to-jsx';
import Link from '@mui/material/Link';

import errorMessages from './errorMessages';
import dynamicLinkMessages from '../brand/messages/DynamicLinkMessages';
import { reportPageLoadError } from '../utils/errorUtils';

const ErrorNoRetry = ({ intl }) => {
    useEffect(() => {
        
        reportPageLoadError('Error NoRetry Page', '');
    }, []);

    return (
        <Box className='error-container'>
            <Typography className='error-desc'>
                {intl.formatMessage(errorMessages.errorNoRetryDescription)}
            </Typography>

            <Typography className='error-check-url'>
                <Markdown
                    options={{
                        overrides: {
                        
                            a: {
                                component: Link,
                                props: {
                                    target: '_blank',
                                    rel: 'noopener'
                                }
                            }
                        }
                    }}
                >
                    {
                        intl.formatMessage(
                            errorMessages.errorNoRetryContactUs,
                            { link: intl.formatMessage(dynamicLinkMessages.noRetryInquiryList) }
                        )
                    }
                </Markdown>
            </Typography>
        </Box>
    );
};

ErrorNoRetry.propTypes = {
    
    intl: intlShape.isRequired
};

export default injectIntl(ErrorNoRetry);
